interface DeleteConfirmModalProps {
  productName: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function DeleteConfirmModal({ productName, onCancel, onConfirm }: DeleteConfirmModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-foreground-950/40 backdrop-blur-sm" onClick={onCancel}></div>
      <div className="relative bg-background-50 rounded-2xl w-full max-w-md border border-background-200/70 p-6">
        <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
          <i className="ri-error-warning-line text-xl text-primary-600"></i>
        </div>
        <h3 className="text-lg font-heading font-bold text-foreground-950 mb-2">Delete Product</h3>
        <p className="text-sm text-foreground-600 mb-6">
          Are you sure you want to delete <strong className="text-foreground-900">{productName}</strong>? This action cannot be undone.
        </p>
        <div className="flex items-center justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2.5 text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-200/70 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-5 py-2.5 bg-primary-600 text-white text-sm font-semibold rounded-lg hover:bg-primary-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Delete Product
          </button>
        </div>
      </div>
    </div>
  );
}